<template>
    <div class="bg-teal-400 rounded-lg p-5">
           <h1 class="text-lg font-bold text-slate-900 mb-5">DATA RUJUKAN</h1>
           <table width="100%" border="0">
                <tr>
                    <td>No Rujukan</td>
                    <td class="font-bold">{{rujukan.noKunjungan}}</td>
                </tr>
                <tr>
                    <td>Diagnosa</td>
                    <td class="font-bold">{{rujukan.diagnosa.nama}}</td>
                </tr>
                <tr>
                    <td>Poli Rujukan</td>
                    <td class="font-bold">{{rujukan.poliRujukan.nama}}</td>
                </tr>
           </table>
       </div>
</template>


<script>
   import { Link } from '@inertiajs/inertia-vue3'
   export default{
       props: {
           rujukan: Object,
       },
       components: {
           Link
       },
   }
</script>